import Link from "next/link";
import React, { useContext, useState, useEffect, useTransition } from "react";
import helper from "../../lib/helper";
import productsModel from "../../models/products.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import { Modal, ToggleButton } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import _ from "lodash";
import { useForm } from "react-hook-form";


export default function Page() {
  const [showLoader, setShowLoader] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedRows, setSelectedRow] = useState([]);
  const [show, setShow] = useState(false);
  const [showExport, setShowExport] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShowExport = () => setShowExport(true);
  const handleCloseExport = () => setShowExport(false);

  const [showInc, setShowInc] = useState(false);

  const handleCloseInc = () => setShowInc(false);
  const handleShowInc = () => setShowInc(true);

  const [showDec, setShowDec] = useState(false);

  const handleCloseDec = () => setShowDec(false);
  const handleShowDec = () => setShowDec(true);
  const router = useRouter();

  const queryParams = router.query;
  queryParams.order_by = queryParams.order_by ?? "created_at";
  queryParams.order_in = queryParams.order_in ?? "desc";
  queryParams.status = queryParams.status ?? "";
  const {
    data: productData,
    mutate: reloadProductData,
    isLoading,
  } = useSWR(
    queryParams || null,
    async () => await productsModel.list(queryParams),
    config.swrConfig,
  );

  const {
    register,
    setValue,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
    setError,
    reset,
  } = useForm();

  const {
    register: registerDecrement,
    handleSubmit: handleSubmitDecrement,
    reset: decrementReset,
  } = useForm();

  const setID = (id) => {
    setSelectedValue(id);
  };

  const handleChangeSelectedRow = (id) => {
    setSelectedRow(_.xor(selectedRows, [id]));
  };
  const deleteSelectedRow = async () => {
    await helper.sweetalert
      .confirm(`confirm to delete Selected row`, "warning")
      .then((result) => {
        setShowLoader(true);
        if (result.isConfirmed) {
          const formData = new FormData();
          formData.append("ids", selectedRows);
          productsModel.bulkDestroy(formData).then(() => {
            reloadProductData().then(() => {
              setShowLoader(false);
            });
          });
        }
      });
  };

  const onSubmitInc = handleSubmit(async (data, event) => {
    console.log("selectedValue", selectedValue);
    const formData = new FormData(event.target);
    // formData.set("content", editorRef.current.getContent());
    await productsModel
      .manageInventory(formData, selectedValue)

      .then((response) => {
        helper.sweetalert.toast(response.data?.message, "success");
        handleCloseInc();
        reset();
        reloadProductData();
        router.push("/products");
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response.data?.message, "error");
        _.each(error.response?.data?.errors, function (err, errorKey) {
          setError(errorKey, { type: "required", message: err });
        });
      });
  });

  const onSubmitDec = handleSubmitDecrement(async (data, event) => {
    const formData = new FormData(event.target);
    // formData.set("content", editorRef.current.getContent());
    await productsModel
      .manageInventory(formData, selectedValue)
      .then((response) => {
        helper.sweetalert.toast(response.data?.message, "success");
        handleCloseDec();
        decrementReset();
        reloadProductData();
        router.push("/products");
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response.data?.message, "error");
        _.each(error.response?.data?.errors, function (err, errorKey) {
          setError(errorKey, { type: "required", message: err });
        });
      });
  });

  function statusFilter(status) {
    queryParams.status = status;
    queryParams.page = 1;
    router.push({ query: queryParams });
  }

  const ExportProducts = handleSubmit(async (data, event) => {
      const formData = new FormData();
  
      formData.set("email", data.email);
      
  
      helper.sweetalert.toast(
        `Email will be sent in few minutes to ${data.email}`
      );
      await productsModel
        .ExportProduct(formData)
        .then((response) => {
          helper.sweetalert.toast(response.data?.message, "success");
          handleCloseExport();
        })
        .catch((error) => {
          console.log(error.response.data?.errors);
          helper.sweetalert.toast(error.response.data?.message, "error");
          _.each(error.response?.data?.errors, function (err, errorKey) {
            setError(errorKey, { type: "required", message: err });
          });
        });
    });

  const columns = [
    {
      Header: (
        <>
          <input
            type="checkbox"
            onChange={() => setSelectedRow(_.map(productData?.data, "id"))}
          />{" "}
        </>
      ),
      id: "id",
      Cell: ({ row }) => (
        <>
          <input
            type="checkbox"
            checked={_.includes(selectedRows, row.original.id)}
            onChange={() => handleChangeSelectedRow(row.original.id)}
          />{" "}
        </>
      ),
    },
    {
      Header: "Image",
      id: "image",
      Cell: ({ row }) => (
        <>
          {" "}
          <img src={row.original.thumbnail} height="40px" width="50px" />{" "}
        </>
      ),
    },
    {
      Header: "Title",
      accessor: "title",
      className: "text-wrap",
    },
    {
      Header: "Category",
      id: "categories",
      Cell: ({ row }) => <> {row.original.categories?.title} </>,
    },
    {
      Header: "SKU",
      accessor: "sku",
    },
    {
      Header: "Quantity",
      accessor: "quantity",
    },
    {
      Header: "Selling-Price",
      accessor: "selling_price",
    },

    {
      Header: "MRP",
      accessor: "mrp",
    },
    {
      Header: "Age_from",
      accessor: "age_from",
    },
    {
      Header: "Age_to",
      accessor: "age_to",
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: false,
      isHidden: true,
      enableHiding: true,
      toggleVisibility: true,
    },
    {
      Header: "Remark",
      accessor: "remark",
      Filter: false,
      isHidden: false,
    },
    {
      Header: "Created",
      accessor: "created_at",
      className: "col-auto text-nowrap",
      Filter: false,
      Cell: ({ row }) => <>{helper.date.dateOnly(row.original.created_at)}</>,
    },
    {
      className: "col-auto text-end",
      Header: "Actions",
      id: "action",

      Cell: ({ row }) => (
        <>
          <div>
            <Dropdown className="btn-group btn-group-sm">
              <Link
                className="btn btn-outline-primary"
                href={`/products/${row.original.id}`}
              >
                <i className="bi bi-eye"></i>
              </Link>
              <Dropdown.Toggle size="sm" variant="outline-primary">
                <i className="bi bi-three-dots-vertical"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  className="btn btn-warning"
                  href={`/products/${row.original.id}/edit`}
                >
                  <i className="bi bi-pencil-square"></i> Edit
                </Dropdown.Item>
                <Dropdown.Divider />
                <Link
                  key={"product-inventory"}
                  title="product inventory"
                  className="btn btn-none"
                  href={`/products/${row.original.id}/inventory`}
                >
                  <i className="bi bi-box"></i> Inventory-log
                </Link>
                <Dropdown.Divider />

                <Dropdown.Item
                  as="button"
                  type="button"
                  className="text-danger"
                  onClick={() =>
                    confirmDelete(row.original.id, row.original.title)
                  }
                >
                  <i className="bi bi-trash"></i> Delete
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  as="button"
                  type="button"
                  className="text-primary"
                  onClick={() => {
                    (handleShowInc(), setID(row.original.id));
                  }}
                >
                  <i className="bi bi-plus"></i> Increase
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  as="button"
                  type="button"
                  className="text-primary"
                  onClick={handleShowDec}
                >
                  <i className="bi bi-dash"></i> Decrease
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];
  const confirmDelete = async (id, title) => {
    await helper.sweetalert
      .confirm(`confirm to delete ${title}`, "warning")
      .then(async (result) => {
        if (result.isConfirmed) {
          setShowLoader(true);
          await productsModel.destroy(id).then((res) => {
            reloadProductData();
            helper.sweetalert.toast(`${title} deleted Successfully`);
          });
          setShowLoader(false);
        }
      });
  };

  return (
    <>
      <Heading title="Products" showLoader={isLoading || showLoader}>
        <div className="btn-group">
          <button className="btn btn-sm btn-primary" onClick={handleShowExport}>
            export
          </button>
          <Modal show={showExport} onHide={handleCloseExport}>
            <Modal.Header closeButton>
              <Modal.Title>Export products</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="form-control">
               
                <input
                  type="email"
                  placeholder="Enter email-id"
                  className={`form-control ${errors?.email && "is-invalid"}`}
                  {...register("email", {
                    required: "Email is required",
                  })}
                />
                <div className="invalid-feedback">
                  {errors.email && errors.email.message}
                </div>

                <button
                  type="button"
                  className="btn btn-sm btn-primary float-end mt-4"
                  onClick={ExportProducts}
                >
                  Generate report
                </button>
              </form>
            </Modal.Body>
          </Modal>

          <button className="btn btn-sm btn-primary" onClick={handleShow}>
            + Create
          </button>
          <Link href="/products/bulkupdate" className="btn btn-sm btn-primary">
            + Bulk-Update
          </Link>
          {/* <Link href="/products/bulkupload" className="btn btn-sm btn-primary">
            + Bulk inventory upload
          </Link> */}
          <Link
            href="/products/bulkinventory"
            className="btn btn-sm btn-primary"
          >
            + Bulk inventory update
          </Link>
        </div>
      </Heading>
      <Modal show={show} size="lg" onHide={handleClose} className="modal-sm">
        <Modal.Header closeButton>
          <Modal.Title>Choose from here...</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6 border-3 border-end text-center p-5">
              <h4>Upload Single product manually</h4>
              <Link href={"products/create"} className="btn btn-primary btn-lg">
                Manual upload
              </Link>
            </div>
            <div className="col-md-6 text-center p-5">
              <h4>Bulk upload products with Excel file</h4>
              <Link
                href={"products/bulkupload"}
                className="btn btn-primary btn-lg"
              >
                Bulk upload
              </Link>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div className="container-fluid">
        <div className="btn-group">
          <ToggleButton
            key="btn-all"
            id={`radio-btn-all}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == ""}
            onChange={(e) => {
              statusFilter("");
            }}
          >
            All
          </ToggleButton>
          <ToggleButton
            key="btn-publish"
            id={`radio-publish}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "publish"}
            onChange={(e) => {
              statusFilter("publish");
            }}
          >
            Publish
          </ToggleButton>
          <ToggleButton
            key="btn-publish"
            id={`radio-pending}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "pending"}
            onChange={(e) => {
              statusFilter("pending");
            }}
          >
            Pending
          </ToggleButton>
          <ToggleButton
            key="btn-rejected"
            id={`radio-rejected}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "reject"}
            onChange={(e) => {
              statusFilter("reject");
            }}
          >
            Rejected
          </ToggleButton>
        </div>

        {selectedRows.length ? (
          <button
            type="button"
            className="btn btn-primary float-end"
            onClick={() => deleteSelectedRow()}
          >
            Delete Selected
          </button>
        ) : (
          ""
        )}
      </div>
      <div className="table-responsive">
        <Table
          key="product-table"
          columns={columns}
          data={productData?.data || []}
        />
        {/* <---------Handle increment */}
        <Modal show={showInc} onHide={handleCloseInc}>
          <Modal.Header closeButton>
            <Modal.Title>Increase inventory</Modal.Title>
          </Modal.Header>
          <form onSubmit={onSubmitInc}>
            <Modal.Body>
              <input
                type="number"
                className="form-control"
                {...register("quantity")}
              />
              <input
                type="hidden"
                className="form-control"
                {...register("types")}
                value="increase"
              />
            </Modal.Body>
            <Modal.Footer>
              <button
                type="submit"
                className="btn btn-sm btn-primary float-end mt-1"
              >
                Submit
              </button>
            </Modal.Footer>
          </form>
        </Modal>
        {/* <---------handle decrement */}
        <Modal show={showDec} onHide={handleCloseDec}>
          <Modal.Header closeButton>
            <Modal.Title>Decrease Inventory</Modal.Title>
          </Modal.Header>
          <form onSubmit={onSubmitDec}>
            <Modal.Body>
              <input
                type="number"
                className="form-control"
                {...registerDecrement("quantity")}
              />
              <input
                type="hidden"
                className="form-control"
                {...registerDecrement("types")}
                value="decrease"
              />
            </Modal.Body>
            <Modal.Footer>
              <button
                type="submit"
                className="btn btn-sm btn-primary float-end mt-1"
              >
                Submit
              </button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
      <div className="card-footer table-responsive">
        <Pagination meta={productData?.meta} />
      </div>
    </>
  );
}
